"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @author by Gor.Hakobyan on 30-Apr-18.
 */
var Answer = /** @class */ (function () {
    function Answer(id, name, questionId, rank) {
        this._id = id;
        this._name = name;
        this._questionId = questionId;
        this._rank = rank;
    }
    Object.defineProperty(Answer.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (value) {
            this._id = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Answer.prototype, "name", {
        get: function () {
            return this._name;
        },
        set: function (value) {
            this._name = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Answer.prototype, "questionId", {
        get: function () {
            return this._questionId;
        },
        set: function (value) {
            this._questionId = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Answer.prototype, "rank", {
        get: function () {
            return this._rank;
        },
        set: function (value) {
            this._rank = value;
        },
        enumerable: true,
        configurable: true
    });
    return Answer;
}());
exports.Answer = Answer;
//# sourceMappingURL=answer.model.js.map